export interface MessageTypesState {
  messageTypes: any[],
  messageTypeItem?: MessageTypeItem
}

export interface MessageTypeFilter {
  name?: string
}

export interface MessageTypeItem {
  id?: number
  name: string,
  description: string
}

export class MessageTypeItemImpl implements MessageTypeItem {
  name: string;
  description: string;

  constructor() {
    this.name = '';
    this.description = '';
  }
}